export default __webpack_public_path__ + "static/media/Headshot-5.be4e4625.png";